export enum DeferredRequestStatus {
  Failed = -1,
  NotStarted = 0,
  InProgress = 1,
  Complete = 2,
}

export interface DeferredRequestProgressResponse {
  progress: number;
  status: DeferredRequestStatus;
  downloadUrl?: string;
}
